// Confirm dialog built on the shared PortalModal shell.

import React from 'react';
import PortalModal, { ModalActions } from './PortalModal';

export default function ConfirmDialog({
  open, title, message, confirmLabel = 'Confirm', onConfirm, onCancel, danger = false,
}) {
  return (
    <PortalModal open={open} onClose={onCancel} title={title} size="narrow">
      <p>{message}</p>
      <ModalActions>
        <button type="button" className="portal-button secondary" onClick={onCancel}>Cancel</button>
        <button type="button" className={`portal-button${danger ? ' danger' : ''}`} onClick={onConfirm}>
          {confirmLabel}
        </button>
      </ModalActions>
    </PortalModal>
  );
}
